import CloseIcon from '@mui/icons-material/Close';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { SelectOption } from 'atoms/Select';
import cn from 'classnames';
import React from 'react';

import s from './SortingSidebar.module.scss';

interface SortingSidebarProps {
  isOpen: boolean;
  isMobile?: boolean;
  onClose: () => void;
  activeOption: string;
  sortOptions: SelectOption[];
  onSelect: (value: string) => void;
}

const SortingSidebar = ({
  isOpen,
  isMobile,
  onClose,
  activeOption,
  sortOptions,
  onSelect
}: SortingSidebarProps) => {
  const selectItem = (val: string | number) => {
    if (typeof val === 'number') return;
    onSelect(val);
    onClose();
  };
  return (
    <Drawer
      open={isOpen}
      anchor="right"
      variant={isMobile ? 'temporary' : 'persistent'}
      PaperProps={{ elevation: 9, sx: { width: '100%' } }}
    >
      <div className={s.SortingSidebar__head}>
        <Typography variant="h3">Sort by</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <div className={s.SortingSidebar__options}>
        {sortOptions.map(({ name, value }) => (
          <button
            className={cn(s.SortingSidebar__option, { isActive: activeOption === value })}
            onClick={() => selectItem(value)}
            key={name}
          >
            {name}
          </button>
        ))}
      </div>
    </Drawer>
  );
};

export default SortingSidebar;
